import currentMonth from './current-month';
import otherMonths from './other-months';

export default {
  currentMonth,
  otherMonths,
};
